<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <!-- cargador tabla -->
    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
      <v-card>
        <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
          <v-row>
            <v-col cols="12" sm="8">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    exact
                    color="primary"
                    class="mr-4"
                    v-bind="attrs"
                    v-on="on"
                    @click="regresar"
                  >
                    <v-icon> mdi-arrow-left </v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>

              Ganadores: {{ categoriaCompetencia.categoria }}
            </v-col>

            <v-col 
              cols="12" 
              sm="4"
              class="d-flex justify-end"
            >
              <v-text-field
                outlined
                dense
                append-icon="mdi-magnify"
                label="Buscar Ganador"
                hide-details
                class="mr-4"
                v-model="searchTable"
              >
              </v-text-field>
              
              <v-btn 
                exact 
                color="primary" 
                @click="open"
              >
                Registrar
              </v-btn>
            </v-col> 
          </v-row>
        </v-card-title>
        <v-data-table
          fixed-header
          height="calc(100vh - 220px)"
          class="elevation-2"
          :headers="headersTable"
          :items="ganadoresWorldSkills"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="detalles(item.id)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>Detalles</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="editar(item.id)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Actualizar</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                  @click="activarAlertaEliminar(item.id)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
          <template v-slot:top>
            <v-dialog
              persistent
              scrollable
              max-width="520px"
              v-model="dialogForm"
            >
              <v-card :loading="loadingForm">
                <v-card-title class="justify-center">
                  <p class="text-h5 font-weight-bold primary--text">
                    {{ formTitle }}
                  </p>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="10">
                        <v-form ref="form" v-model="form">
                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Competencia"
                            v-model="competenciaSeleccionada"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Habilidad"
                            v-model="habilidadSeleccionada"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            :disabled="disabledForm"
                            append-icon="mdi-magnify"
                            type="number"
                            label="Número de Identificación"
                            min="1"
                            v-model="identificacion"
                            :rules="identificacionReglas"
                            :loading="loadingTextField"
                            :error-messages="mensajeIdentificacion"
                            @keydown.enter="persona(identificacion)"
                            @click:append="persona(identificacion)"
                          >
                          </v-text-field>

                          <template v-if="validarPersona == true">
                            <v-text-field
                              outlined
                              dense
                              disabled
                              type="text"
                              label="Nombres"
                              v-model="nombres"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              disabled
                              type="text"
                              label="Apellidos"
                              v-model="apellidos"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              disabled
                              type="text"
                              label="Fecha de Nacimiento"
                              v-model="fecha_nacimiento"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              disabled
                              type="text"
                              label="Género"
                              v-model="genero"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              disabled
                              type="text"
                              label="Programa de Formación"
                              v-model="programaFormacion"
                            >
                            </v-text-field>

                            <v-text-field
                              outlined
                              dense
                              disabled
                              type="number"
                              label="Número de Ficha"
                              v-model="numeroFicha"
                            >
                            </v-text-field>

                            <v-select
                              outlined
                              dense
                              label="Tipo de Medalla*"
                              :items="medallas"
                              v-model="medalla"
                              :rules="medallaReglas"
                            >
                            </v-select>

                            <v-text-field
                              outlined
                              dense
                              type="number"
                              label="Puntaje"
                              v-model="puntaje"
                            >
                            </v-text-field>

                            <v-textarea
                              outlined
                              rows="4"
                              label="Descripción"
                              v-model="descripcion"
                            >
                            </v-textarea>
                          </template>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="close"> Cancelar </v-btn>

                  <template v-if="editedIndex === -1">
                    <v-btn text exact color="primary" @click="registrar">
                      Registrar
                    </v-btn>
                  </template>

                  <template v-else>
                    <v-btn text exact color="primary" @click="actualizar">
                      Actualizar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
        <v-dialog v-model="dialogDelete" max-width="400px">
          <v-card>
            <v-card-title class="justify-center text-h6">
              ¿Desea eliminar el ganador?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDelete">
                Cancelar
              </v-btn>

              <v-btn text color="error" @click="eliminar">
                OK
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </template>
  </div>
</template>

<script>
import Alert from "../../../components/admin/Alert.vue";
export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,
    loadingTextField: false,

    alert: false,
    alertType: "",
    alertTitle: "",
    alertMessage: "",
    loadingForm: false,
    form: true,

    dialogForm: false,
    disabledForm: false,
    dialogDelete: false,

    competenciaSeleccionada: "",

    habilidadSeleccionada: "",

    identificacion: null,
    identificacionReglas: [
      (v) => !!v || "Escriba un número de identificación",
      (v) => v > 0 || "El número debe ser mayor a cero",
    ],
    mensajeIdentificacion: "",

    programaFormacion: null,
    programaFormacionReglas: [
      (v) => !!v || "Seleccione un programa de formación",
    ],

    numeroFicha: null,
    numeroFichaReglas: [(v) => !!v || "Escriba un número de ficha"],

    medalla: null,
    medallas: ["ORO", "PLATA", "BRONCE", "EXCELENCIA"],
    medallaReglas: [(v) => !!v || "Seleccione una medalla"],

    puntaje: null,

    descripcion: null,

    ganadorId: null,
    participanteId: null,
    idPersona: null,
    nombres: null,
    apellidos: null,
    fecha_nacimiento: null,
    genero: null,
    validarPersona: false,

    headersTable: [
      {
        text: "Identificación",
        value: "identificacion",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"],
      },
      {
        text: "Nombres",
        value: "nombres",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Apellidos",
        value: "apellidos",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Medalla",
        value: "medalla",
        align: "start",
        width: "10%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Puntaje",
        value: "puntaje",
        align: "start",
        width: "10%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Centro de Formación",
        value: "centro_formacion",
        align: "start",
        width: "20%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],

    editedIndex: -1,
    temEvaluacion_id: null,
  }),
  components: {
    Alert,
  },

  mounted() {
    const categoriaCompetencia = {
      competencia_id: this.$route.params.id_competencia,
      categoria_id: this.$route.params.id_categoria,
    };

    this.$store.dispatch("crearCentrosFormacion");
    this.$store.dispatch("gestionarGanadorWorldSkills");
    this.$store.dispatch("gestionarParticipantesWorldskills");
    this.$store.dispatch("detallesCategoriaCompetencia", categoriaCompetencia);
    this.$store.dispatch("detallesCompetencia", this.$route.params.id_competencia);

    setTimeout(() => {
      this.skeletonLoader = false;
    }, 2000);
  },

  computed: {
    usuario() {
      return this.$store.getters.usuario;
    },

    perfilAdminNacional() {
      return this.$store.getters.perfilAdminNacional;
    },

    perfilLiderNacional() {
      return this.$store.getters.perfilLiderNacional;
    },

    perfilEnlaceRegional() {
      return this.$store.getters.perfilEnlaceRegional;
    },

    perfilExpertoRegional() {
      return this.$store.getters.perfilExpertoRegional;
    },

    centroFormacionUsuario() {
      return this.$store.getters.obtenerCentroFormacion(this.usuario.centro_formacion_id);
    },

    ganadoresWorldSkills() {
      const ganadoresWorldSkills = this.$store.getters.obtenerGanadoresWorldSkills(this.$route.params.id_competencia,
        this.$route.params.id_categoria);

      if(this.perfilEnlaceRegional) {
        const ganadores = ganadoresWorldSkills.filter((ganador) => ganador.regional_id == this.centroFormacionUsuario.regional_id);

        return ganadores;
      }

      return ganadoresWorldSkills;
    },

    formTitle() {
      return this.editedIndex === -1
        ? "Registrar Ganador"
        : "Actualizar Ganador";
    },

    competencia() {
      return this.$store.getters.obtenerCompetencia;
    },

    categoriaCompetencia() {
      return this.$store.getters.obtenerCategoriaCompetencia;
    },

    participantesWorldSkills() {
      return this.$store.getters.obtenerParticipantesWorldskills(this.$route.params.id_competencia,
        this.$route.params.id_categoria
      );
    },
  },

  watch: {
    dialogForm(val) {
      val || this.close();
    },

    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    open() {
      this.dialogForm = true;
      this.competenciaSeleccionada = this.competencia.competencia;
      this.habilidadSeleccionada = this.categoriaCompetencia.categoria;
    },

    close() {
      this.dialogForm = false;
      this.disabledForm = false;
      this.editedIndex = -1;
      this.validarPersona = false;
      this.$refs.form.reset();
      this.mensajeIdentificacion = "";
    },

    persona(identificacion) {
      this.loadingTextField = true;
      const participante = this.participantesWorldSkills.find((participante) => participante.identificacion == identificacion);

      if (participante != null) {
        this.mensajeIdentificacion = "";
        this.idPersona = participante.persona_id;
        this.participanteId = participante.id;
        this.nombres = participante.nombres;
        this.apellidos = participante.apellidos;
        this.fecha_nacimiento = participante.fecha_nacimiento;
        this.genero = participante.genero;
        this.programaFormacion = participante.programa_formacion;
        this.numeroFicha = participante.numero_ficha;
        this.validarPersona = true;
        this.loadingTextField = false;
      } 
      else {
        this.validarPersona = false;
        this.mensajeIdentificacion = "Número de identificación no registrado como participante para esta habilidad";
        setTimeout(() => {
          this.loadingTextField = false;
        }, 1000);
      }
    },

    registrar() {
      if (this.$refs.form.validate()) {
        if (this.validarPersona) {
          this.loadingForm = true;

          const ganador = {
            participante_id: this.participanteId,
            persona_id: this.idPersona,
            puntaje: this.puntaje,
            medalla: this.medalla,
            descripcion: this.descripcion,
            competencia_id: this.$route.params.id_competencia,
            categoria_id: this.$route.params.id_categoria,
          };

          this.$store.dispatch("registrarGanadorWorldSkills", ganador)
          .then((response) => {
            if (response.status == "success") {
              let message = response.message.split(",");
              this.loadingForm = false;
              this.$refs.form.reset();
              this.alert = true;
              this.alertTitle = message[0];
              this.alertMessage = message[1];
              this.alertType = "success--text";
              this.alert = true;

              this.skeletonLoader = true;

              this.$store.dispatch("gestionarGanadorWorldSkills");

              this.close();

              setTimeout(() => {
                this.alert = false;
                this.skeletonLoader = false;
              }, 2000);
            } else {
              this.loadingForm = false;
              this.alert = true;
              this.alertType = "error--text";
              this.alertTitle = "Error";

              for (const error in response.message) {
                this.alertMessage = response.message[error][0];
              }

              setTimeout(() => {
                this.alert = false;
              }, 3000);
            }
          })
          .catch(() => {});
        } 
        else {
          this.alertTitle = "Error";
          this.alertMessage = "Número de identificación no encontrado";
          this.alertType = "error--text";
          this.alert = true;

          setTimeout(() => {
            this.alert = false;
          }, 3000);
        }
      }
    },

    detalles(ganador) {
      this.$router.push({
        name: "ganador-detalle",
        params: {
          id_evaluacion: ganador,
          id_competencia: this.$route.params.id_competencia,
          id_categoria: this.$route.params.id_categoria,
        },
      });
    },

    editar(ganador) {
      this.editedIndex = 1;
      this.disabledForm = true;
      this.$store.dispatch("editarGanadorWorldSkills", ganador)
      .then((response) => {
        this.ganadorId = ganador;
        this.participanteId = response.participante.id_participante,
        this.competenciaSeleccionada = this.competencia.competencia;
        this.habilidadSeleccionada = this.categoriaCompetencia.categoria;
        this.identificacion = response.participante.persona.identificacion;
        this.nombres =
          response.participante.persona.primer_nombre +
          " " +
          response.participante.persona.segundo_nombre;
        this.apellidos =
          response.participante.persona.primer_apellido +
          " " +
          response.participante.persona.segundo_apellido;
        this.fecha_nacimiento =
          response.participante.persona.fecha_nacimiento;
        this.genero = response.participante.persona.genero.genero;
        this.programaFormacion =
          response.participante.programa_formacion.programa_formacion;
        this.numeroFicha = response.participante.numero_ficha;
        this.medalla = response.medalla;
        this.puntaje = response.puntaje;
        this.descripcion = response.descripcion;
        this.validarPersona = true;
        this.dialogForm = true;
      })
      .catch(() => {});
    },

    actualizar() {
      if (this.$refs.form.validate()) {
        if (this.validarPersona) {
          const ganador = {
            id: this.ganadorId,
            participante_id: this.participanteId,
            persona_id: this.idPersona,
            puntaje: this.puntaje,
            medalla: this.medalla,
            descripcion: this.descripcion,
            competencia_id: this.$route.params.id_competencia,
            categoria_id: this.$route.params.id_categoria,
          };

          this.loadingForm = true;
          this.$store.dispatch("actualizarGanadorWorldSkills", ganador)
            .then((response) => {
              if (response.status == "success") {
                this.close();
                this.loadingForm = false;

                let message = response.message.split(",");
                this.alertType = "success--text";
                this.alertTitle = message[0];
                this.alertMessage = message[1];
                this.alert = true;

                this.skeletonLoader = true;

                this.$store.dispatch("gestionarGanadorWorldSkills");

                setTimeout(() => {
                  this.alert = false;
                  this.skeletonLoader = false;
                }, 1000);
              } 
              else {
                this.loadingForm = false;
                this.alertType = "error--text";
                this.alertTitle = "Error";

                for (const error in response.message) {
                  this.alertMessage = response.message[error][0];
                }

                this.alert = true;

                setTimeout(() => {
                  this.alert = false;
                }, 3000);
              }
            })
            .catch(() => {});
        } 
        else {
          this.alertTitle = "Error";
          this.alertMessage = "Número de identificación no encontrado";
          this.alertType = "error--text";
          this.alert = true;

          setTimeout(() => {
            this.alert = false;
          }, 3000);
        }
      }
    },

    activarAlertaEliminar(ganador) {
      this.temEvaluacion_id = ganador;
      this.dialogDelete = true;
    },

    eliminar() {
      this.dialogDelete = false;
      this.$store.dispatch("eliminarGanadorWorldSkills", this.temEvaluacion_id)
        .then((response) => {
          if (response.status == "success") {
            let message = response.message.split(",");
            this.alertTitle = message[0];
            this.alertMessage = message[1];
            this.alertType = "success--text";
            this.alert = true;

            this.skeletonLoader = true;

            this.$store.dispatch("gestionarGanadorWorldSkills");

            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false;
            }, 2000);
          } 
          else {
            this.loadingForm = false;
            this.alertType = "error--text";
            this.alertTitle = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0];
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false;
            }, 3000);
          }
        })
        .catch(() => {});
    },

    closeDelete() {
      this.dialogDelete = false;
      this.editedIndex = -1;
    },

    regresar() {
      this.$router.back();
    },
  },
};
</script>
